<template>
    <p v-if="loading" class="text-center">Yükleniyor...</p>
    <p v-else-if="error" class="text-center">Hata oluştu: {{ error }}</p>
    <div v-else class="row">
        <div class="col-xxl-4 col-xl-6">
            <div class="card stretch stretch-full">
                <div class="card-body">
                    <div class="mb-4 text-center">
                        <div class="wd-150 ht-150 mx-auto mb-3 position-relative">
                            <div class="avatar-image wd-150 ht-150 border border-5 border-gray-3">
                                <img :src="animal.image" alt="" class="img-fluid">
                            </div>
                            <div class="wd-10 ht-10 text-success rounded-circle position-absolute translate-middle"
                                style="top: 76%; right: 10px">
                                <i class="bi bi-patch-check-fill"></i>
                            </div>
                        </div>
                        <div class="mb-4">
                            <a href="javascript:void(0);" class="fs-14 fw-bold d-block"> {{ animal.id_number }}</a>
                            <a href="javascript:void(0);" class="fs-12 fw-normal text-muted d-block">[ {{
                                animal.species_name
                            }} ]</a>
                        </div>
                        <div class="fs-12 fw-normal text-muted text-center d-flex flex-wrap gap-3 mb-4">
                            <div
                                class="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                                <p class="fs-12 text-muted mb-0">Yaşı</p>
                                <h6 class="fs-15 fw-bolder">{{ animal.age }}</h6>
                            </div>
                            <div
                                class="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                                <p class="fs-12 text-muted mb-0">Cinsiyet</p>
                                <h6 class="fs-15 fw-bolder">{{ animal.gender }}</h6>
                            </div>
                            <div
                                class="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                                <p class="fs-12 text-muted mb-0">Cinsi</p>
                                <h6 class="fs-15 fw-bolder">{{ animal.breed_name }}</h6>
                            </div>
                        </div>
                    </div>
                    <ul class="list-unstyled mb-4">
                        <li class="hstack justify-content-between mb-4">
                            <span class="text-muted fw-medium hstack gap-3">
                                <h5>Bulunduğu Barınak</h5>
                            </span>
                            <p class="float-end">{{ animal.shelter?.shelter_name || 'Yok' }}</p>
                        </li>
                        <h5><span v-if="animal.owner">Geldiği yer / </span><span
                                v-if="!animal.owner && animal.owner_address">Alındığı
                                Yer /
                            </span><span v-if="animal.owner">Sahibi /</span></h5>
                        <br>
                        <li class="hstack justify-content-between mb-4" v-if="animal.owner">
                            <p class="float-end">{{ animal.owner }}</p>
                        </li>
                        <li class="hstack justify-content-between mb-4" v-if="animal.owner_address">
                            <span class="text-muted fw-medium hstack gap-3"><i class="feather-map-pin"></i>Adresi</span>
                            <p class="float-end">{{ animal.owner_address }}</p>
                        </li>
                        <li class="hstack justify-content-between mb-4" v-if="animal.owner_phone">
                            <span class="text-muted fw-medium hstack gap-3"><i class="feather-phone"></i>Telefonu</span>
                            <a class="float-end">{{ animal.owner_phone }}</a>
                        </li>
                        <li class="hstack justify-content-between mb-0" v-if="animal.owner_email">
                            <span class="text-muted fw-medium hstack gap-3"><i class="feather-mail"></i>E-Posta</span>
                            <p class="float-end">{{ animal.owner_email }}</p>
                        </li>
                    </ul>
                    <div class="d-flex gap-2 text-center pt-4">
                        <button @click="handleDelete(animal.id)" class="w-50 btn btn-danger">
                            <i class="feather-trash-2 me-2"></i>
                            <span>SİL</span>
                        </button>
                        <router-link :to="`/animal/edit/${animalId}`" class="w-50 btn btn-primary">
                            <i class="feather-edit me-2"></i>
                            <span>DÜZENLE</span>
                        </router-link>
                        <button @click="isTransfer = true; fetchShelters()" :disabled="isTransfer"
                            class="w-50 btn btn-success">
                            <i class="feather-repeat me-2"></i>
                            <span>TRANSFER ET</span>
                        </button>
                    </div>
                    <div class="d-flex gap-2 text-center pt-4" v-if="isTransfer">
                        <select class="form-select form-select-md" v-model="domShelters">
                            <option value="" disabled></option>
                            <option v-for="shelter in shelters" :key="shelter.id" :value="shelter.id">
                                {{ shelter.name }}</option>
                        </select>
                        <button @click=" shelterTransfer()" class="btn btn-success">
                            <i class="feather-check-circle me-2"></i>
                        </button>
                        <button @click="isTransfer = false;" class="btn btn-warning">
                            <i class="feather-x-circle me-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xxl-8 col-xl-6">
            <div class="card border-top-0">
                <div class="card-header p-0">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs flex-wrap w-100 text-center customers-nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item flex-fill border-top" role="presentation">
                            <a href="javascript:void(0);" class="nav-link active" data-bs-toggle="tab"
                                data-bs-target="#overviewTab" role="tab">Genel Bilgiler</a>
                        </li>
                        <li class="nav-item flex-fill border-top" role="presentation">
                            <a style="cursor: pointer;" class=" nav-link" data-bs-toggle="tab"
                                @click="this.$refs.animal_examinations.fetchAnimalExaminations()"
                                data-bs-target="#examinationTab1" role="tab">Muayeneler</a>
                        </li>
                        <li class="nav-item flex-fill border-top" role="presentation">
                            <a style="cursor: pointer;" class="nav-link" data-bs-toggle="tab"
                                @click="this.$refs.animal_medications.fetchMedications()" data-bs-target="#treatmentTab"
                                role="tab">Tedaviler</a>
                        </li>
                        <li class="nav-item flex-fill border-top" role="presentation">
                            <a style="cursor: pointer;" class="nav-link" data-bs-toggle="tab"
                                @click="this.$refs.animal_transactions.fetchAnimalTransactions()"
                                data-bs-target="#transactionTab" role="tab">Tranfer Geçmişi</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div class="tab-pane fade show active p-4" id="overviewTab" role="tabpanel">
                        <div class="about-section mb-5">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0">Davranış Şekli:</h5>
                            </div>
                            {{ animal.behavior_pattern }}
                        </div>
                        <div class="about-section mb-5">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0">Diğer Hususlar:</h5>
                            </div>
                            {{ animal.description }}
                        </div>
                        <div class="profile-details mb-5">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0">Detaylar:</h5>
                                <router-link class="btn btn-sm btn-primary"
                                    :to="`/animal/edit/${animalId}`">Düzenle</router-link>
                            </div>
                            <div class="row g-0 mb-4">
                                <div class="col-sm-3 text-muted">Barınağa Geliş Tarihi:</div>
                                <div class="col-sm-9 fw-semibold">{{ formatDate(animal.arrival_date) }}</div>
                            </div>
                            <div class="row g-0 mb-4">
                                <div class="col-sm-3 text-muted">Barınaktan Ayrılış Tarihi:</div>
                                <div class="col-sm-9 fw-semibold">{{ formatDate(animal.surrender_date) }}</div>
                            </div>
                            <div class="row g-0 mb-4">
                                <div class="col-sm-3 text-muted">Geldiği Yer:</div>
                                <div class="col-sm-9 fw-semibold">{{ animal.owner_address }}</div>
                            </div>
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0">Sahibinin:</h5>
                            </div>
                            <div class="row g-0 mb-4">
                                <div class="col-sm-3 text-muted">Adı Soyadı:</div>
                                <div class="col-sm-9 fw-semibold">{{ animal.owner }}</div>
                            </div>
                            <div class="row g-0 mb-4">
                                <div class="col-sm-3 text-muted">Telefonu:</div>
                                <div class="col-sm-9 fw-semibold">{{ animal.owner_phone }}</div>
                            </div>
                            <div class="row g-0 mb-4">
                                <div class="col-sm-3 text-muted">E-Posta Adresi:</div>
                                <div class="col-sm-9 fw-semibold">{{ animal.owner_email }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="examinationTab1" role="tabpanel">
                        <AnimalExaminations ref="animal_examinations" :animalId="animalId" />
                    </div>
                    <div class="tab-pane fade" id="treatmentTab" role="tabpanel" v-if="animal.shelter">
                        <AnimalMedication ref="animal_medications" :animalId="animalId"
                            :shelterId="animal.shelter.shelter_id" :warehouseId="animal.shelter.warehouse_id" />
                    </div>
                    <div class="tab-pane fade" id="transactionTab" role="tabpanel">
                        <AnimalTransactions ref="animal_transactions" :animalId="animalId" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { deleteAnimal } from '../../services/apiService';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import AnimalExaminations from './AnimalExaminations.vue';
import AnimalMedication from './AnimalMedication.vue';
import AnimalTransactions from './AnimalTransactions.vue';

export default {
    name: 'ShowDetails',
    components: {
        AnimalExaminations,
        AnimalMedication,
        AnimalTransactions,
    },
    data() {
        return {
            animal: {},
            animal_transaction: {
                animal: 0,
                from_shelter: 0,
                to_shelter: 0,
            },
            loading: true,
            error: null,
            medicines: [],
            domShelters: [],
            shelters: [],
            isTransfer: false,
            oldShelter: null,
            animalId: this.$route.params.id,
        }
    },
    async mounted() {
        this.animalId = this.$route.params.id;

        await this.fetchAnimal();
    },
    methods: {
        async fetchAnimal() {
            this.animalId = this.$route.params.id;
            console.log(this.animalId);
            try {
                const response = await this.$axios.get(`animal/${this.animalId}/`);
                console.log(response.data);
                this.animal = response.data;
                if (this.animal.shelter) {
                    this.oldShelter = this.animal.shelter.shelter_id;
                }
                console.log('oldShelter: ', this.oldShelter);
            } catch (error) {
                this.error = error;
                console.error(error);
            } finally {
                this.loading = false;
            }

        },
        async shelterTransfer() {
            console.log('selectedShelter:', this.domShelters);
            try {
                this.animalId = this.$route.params.id;
                this.animal_transaction.animal = this.animalId;
                this.animal_transaction.from_shelter = this.oldShelter;
                this.animal_transaction.to_shelter = this.domShelters;
                console.log(this.animal_transaction);
                await this.$axios.post(`animal_transaction/`, this.animal_transaction);
                // this.AnimalTransactions.animal_transactions.unshift(this.animal_transaction);
                this.$refs.animal_transactions.fetchAnimalTransactions();
                await this.fetchAnimal();
                this.isTransfer = false;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchShelters() {
            try {
                const response = await this.$axios.get('animal_shelter/')
                this.shelters = response.data.results;
            } catch (error) {
                console.error(error);
                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage, // HTML olarak göster (Satır atlamaları çalışsın)
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },
        handleDelete(id) {
            deleteAnimal(id)
                .then(() => {
                    this.$router.push({ name: 'Animals' });
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    }
}
</script>
<style scoped>
.multiselect {
    display: block;
    width: 100%;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border:
        .5px solid #ced4da;
    -webkit-appearance:
        none;
    -moz-appearance:
        none;
    appearance: none;
    border-radius:
        .375rem;
    transition:
        border-color .15s ease, box-shadow .15s ease;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-spinner {
    -moz-appearance: textfield;
    text-align: right;
}
</style>